import { useEffect } from 'react';
import { useAuthStore } from '@/stores/useAuthStore';
import { useSiteStore } from '@/stores/useSiteStore';
import { useSiteAccessStore } from '@/stores/useSiteAccessStore';
import { useCameraStore } from '@/stores/useCameraStore';
import { useAlarmStore } from '@/stores/useAlarmStore';
import { useFloorPlanStore } from '@/stores/useFloorPlanStore';
import { useUIStore } from '@/stores/useUIStore';
import { useSiteMembersStore } from '@/stores/useSiteMembersStore';

function clearSiteData() {
  useCameraStore.getState().reset();
  useAlarmStore.getState().reset();
  useFloorPlanStore.getState().reset();
  useSiteMembersStore.getState().reset();
  useSiteStore.setState((s) => ({ zones: [], floors: [], selectedZone: null,
    selectedFloor: null, generation: s.generation + 1 }));
  useUIStore.setState({ showIncidentReport: false, showCameraManagement: false,
    showWorkerManagement: false, showTaskManagement: false });
}

export function useSiteAccessLifecycle() {
  useEffect(() => {
    const loadCurrent = () => {
      clearSiteData();
      useSiteAccessStore.getState().reset();
      const { selectedSite } = useSiteStore.getState();
      if (selectedSite && useAuthStore.getState().isAuthenticated) {
        void useSiteAccessStore.getState().load(selectedSite);
      }
    };
    const unsubscribeSite = useSiteStore.subscribe((s, prev) => {
      if (s.selectedSite !== prev.selectedSite) loadCurrent();
    });
    const unsubscribeAuth = useAuthStore.subscribe((s, prev) => {
      if (!s.isAuthenticated && prev.isAuthenticated) {
        clearSiteData();
        useSiteAccessStore.getState().reset();
        useSiteStore.getState().reset();
      } else if (s.isAuthenticated && (!prev.isAuthenticated || s.user?.id !== prev.user?.id)) {
        if (prev.user?.id && s.user?.id && prev.user.id !== s.user.id) useSiteStore.getState().reset();
        loadCurrent();
      }
    });
    const unsubscribeAccess = useSiteAccessStore.subscribe((s, prev) => {
      if (s.revision !== prev.revision) {
        clearSiteData();
        if (s.status === 'ready' && s.siteId) void useSiteStore.getState().fetchZones(s.siteId);
      }
    });
    const refresh = () => {
      const { selectedSite } = useSiteStore.getState();
      if (selectedSite && useAuthStore.getState().isAuthenticated) {
        void useSiteAccessStore.getState().load(selectedSite, true);
      }
    };
    const denied = () => loadCurrent();
    window.addEventListener('cctv:permission-denied', denied);
    window.addEventListener('focus', refresh);
    const interval = setInterval(refresh, 30000);
    loadCurrent();
    return () => {
      unsubscribeSite(); unsubscribeAuth(); unsubscribeAccess();
      window.removeEventListener('cctv:permission-denied', denied);
      window.removeEventListener('focus', refresh);
      clearInterval(interval);
    };
  }, []);
}
